import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';

/** Replace with the live Sideline Ready checkout URL. */
const CHECKOUT_URL = 'https://sideline-ready.impultienda.ar/checkout';
const included = ['6 complete volumes', '142 Practice Cards, print-ready', '5 instant-use bonuses', 'Flag 5v5, 7v7 and youth tackle', 'Game-week plans and the Game-Week Loop', 'Lifetime access to your files'];
const spines = [{
  n: '1',
  c: 'bg-turf'
}, {
  n: '2',
  c: 'bg-q3'
}, {
  n: '3',
  c: 'bg-q4'
}, {
  n: '4',
  c: 'bg-q1'
}, {
  n: '5',
  c: 'bg-[#6C4AB6]'
}, {
  n: '6',
  c: 'bg-[#12858A]'
}];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-203" data-mp="20sv8mn7thoyc">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-204" data-mp="3h638ob618upi">
        <div className="text-center" data-id="element-205" data-mp="3c8ju1a5fafx1">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-206" data-mp="3c7ibylpzot5t">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-207" data-mp="3w1t7hufwuz6n">
            The whole season, for less than one playbook
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-ice-dark bg-white shadow-card" data-id="element-208" data-mp="erlefksfora6">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-209" data-mp="3d9qoicfsr6t8">
            <h3 className="font-display text-xl uppercase tracking-wide text-white sm:text-2xl" data-id="element-210" data-mp="3d74hqf0qcvc2">
              Sideline Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-gold-hover" data-id="element-211" data-mp="3n6da53fy61wb">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-212" data-mp="3rzoduvpgq2k0">
            {/* Six-volume visual, built in markup */}
            <div className="flex items-end justify-center gap-2 rounded-2xl bg-ice px-4 py-6" data-id="element-213" data-mp="2ugn1h9x33s7l">
              {spines.map(s => <div key={s.n} className={`flex h-24 w-9 flex-col items-center justify-between rounded-md ${s.c} py-2 shadow-card sm:h-28 sm:w-11`} data-id="element-214" data-mp="2rgcyy442ytzh">
                  <span className="font-display text-base text-white/90" data-id="element-215" data-mp="316xqj7lc6y8w">
                    {s.n}
                  </span>
                  <span className="h-6 w-[3px] rounded-full bg-white/40" data-id="element-216" data-mp="2w8wc4zyuvn3r" />
                  <span className="text-[7px] font-bold uppercase tracking-widest text-white/80" data-id="element-217" data-mp="28h7ceyjpfwcs">
                    Vol
                  </span>
                </div>)}
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-218" data-mp="2iggbu6xca36j">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-219" data-mp="2dg23enrtsr7z">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-220" data-mp="3tutxr68j88jx">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-221" data-mp="3ovgz7o8atd1i" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-222" data-mp="3nf38cyztabz3">
              <p className="text-[13px] text-ink-soft" data-id="element-223" data-mp="3nh684aqrnjh0">
                A single playbook usually runs $30&ndash;50. This is the whole
                season.
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-224" data-mp="j1eu279zv5ga">
                <span className="mt-2.5 font-display text-3xl" data-id="element-225" data-mp="o07zdcf4nq5d">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-226" data-mp="a8tc2te6t2si">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-227" data-mp="e9dcc5u24miv">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-228" data-mp="11xmosh5drxxc">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-229" data-mp="16r94ki6uchxd">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-230" data-mp="3a6uj0s7k9xfk">
                  No subscription
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-231" data-mp="3192bwbbztw39">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-232" data-mp="3szoydn93jrkb">
                Get Sideline Ready now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-233" data-mp="3k6v3ihh62jlc">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-234" data-mp="kjwyhe2wc02i">
                <li className="flex items-center gap-1.5" data-id="element-235" data-mp="fr3synzlsnpd">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-236" data-mp="1yfwvbk1debo8" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-237" data-mp="23ehx3nw9t3es">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-238" data-mp="27fjyaa9qzpje" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-239" data-mp="2cg7ncqef1waz">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-240" data-mp="2hesnkpto4fzf" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-241" data-mp="2v5e9knef561j">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}